import * as React from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import { Translate } from '../../../../shared/LanguageService';

interface IInProgressOrderRowImagesSectionProps {
    orderRowId: any;
    inProgressFiles: any[];
    orderId: any;
}

const InProgressOrderRowImagesSection = (props: IInProgressOrderRowImagesSectionProps) => {
    return (
        <div>
            <h4>{Translate('image-processing/header/uploads-in-progress')}</h4>
            <ListGroup>
                {props.inProgressFiles.map((x, index) => (
                    <ListGroupItem key={'inprogress-filenames-' + index}>
                        {x.filename}
                    </ListGroupItem>
                ))}
            </ListGroup>
        </div>
    );
};

export default InProgressOrderRowImagesSection;
